var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    rx: 82,
    fill: "#D5DAE8",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6708 92.2891C69.302 92.2891 57.8828 94.3968 57.8828 102.828C57.8828 111.262 69.2307 113.444 82.6708 113.444C96.0396 113.444 107.459 111.34 107.459 102.905C107.459 94.4712 96.114 92.2891 82.6708 92.2891Z",
    fill: "#C2C6D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82.67 84.2579C91.7768 84.2579 99.0734 76.9583 99.0734 67.8546C99.0734 58.7509 91.7768 51.4512 82.67 51.4512C73.5663 51.4512 66.2666 58.7509 66.2666 67.8546C66.2666 76.9583 73.5663 84.2579 82.67 84.2579Z",
    fill: "#C2C6D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfile);
export default __webpack_public_path__ + "static/media/empty-profile.883c8cc57bbead220e9f886f145454aa.svg";
export { ForwardRef as ReactComponent };